const TOTAL_STEPS = 6;

const MIN_IMGS = 2;
const MAX_IMGS = 99;

const MIN_DOCS = 1;
const MAX_DOCS = 10;

const IMG_TYPE = 1;
const PDF_TYPE = 2;
const DOC_TYPE = 3;

const INPUT_TYPE = {
  DROPDOWN: 1,
  TEXT: 2,
  CHECKBOX: 3,
  TEXTAREA: 4,
  DATE: 5,
  FILE: 6,
  BUTTON: 7,
};

const INPUT_FIELD_TYPE = {
  NUMBER: 1,
  EMAIL: 2,
  ALPHABET: 3,
  ALPHANUMERIC: 4,
  NULL: null,
};

const INPUT_FIELD_TYPE_MAP = {
  1: "number",
  2: "email",
  3: "text",
  4: "text",
};

const PROPERTY_STATUS = {
  ACTIVE: "active",
  WITHDRAWAL: "withdrawal",
  EXPIRED: "expired",
  PENDING: "pending",
  SOLD: "sold",
};

const PROPERTY_STATUS_CODE = {
  ACTIVE: 1,
  WITHDRAWAL: 2,
  EXPIRED: 3,
  PENDING: 4,
  SOLD: 5,
  INCOMPLETE: 6,
};

const GROUP_NAMES = {
  BASIC: "Basic",
  PRICE_AND_OWNERSHIP: "price_and_ownership",
  TAXES: "taxes",
  LOT_AND_LAND_INFORMATION: "lot_and_land_info",
  BUILDING_AND_EXTERIOR: "building_and_exterior",
  INTERIOR: "interior",
  FOUNDATION: "foundation",
  ROOMS: "rooms",
  ASSOCIATION: "association",
  TERMS_AND_COMPENSATION: "terms_and_compensation",
};

const GROUP_NAMES_FULL = {
  BASIC: "Basic",
  PRICE_AND_OWNERSHIP: "Price & Onwership",
  TAXES: "Taxes",
  LOT_AND_LAND_INFORMATION: "LOT and Land Information",
  BUILDING_AND_EXTERIOR: "Building & Exterior",
  INTERIOR: "Interior",
  FOUNDATION: "Foundation",
  ROOMS: "Rooms",
  ASSOCIATION: "Association",
  TERMS_AND_COMPENSATION: "Terms & Compensation",
};

const STEP_GROUPS = [
  [GROUP_NAMES.PRICE_AND_OWNERSHIP, GROUP_NAMES.TAXES, GROUP_NAMES.LOT_AND_LAND_INFORMATION],
  [GROUP_NAMES.BUILDING_AND_EXTERIOR],
  [GROUP_NAMES.INTERIOR],
  [GROUP_NAMES.FOUNDATION, GROUP_NAMES.ROOMS],
  [GROUP_NAMES.ASSOCIATION, GROUP_NAMES.TERMS_AND_COMPENSATION],
];

const FIELD_ADD_ROOM = "Add Room";

const ROOM_KEYS = {
  ROOM_TYPE: "Room Type (Max 1)",
  LEVEL: "Level (Max 1)",
  FLOORING: "Flooring (Max 1)",
  WIDTH: "Room Width",
  LENGTH: "Room Length",
};

const PROPERTY_FORM = {
  TOTAL_STEPS,
  MIN_IMGS,
  MAX_IMGS,
  MIN_DOCS,
  MAX_DOCS,
  IMG_TYPE,
  PDF_TYPE,
  DOC_TYPE,
  INPUT_TYPE,
  INPUT_FIELD_TYPE,
  INPUT_FIELD_TYPE_MAP,
  PROPERTY_STATUS,
  PROPERTY_STATUS_CODE,
  GROUP_NAMES,
  GROUP_NAMES_FULL,
  STEP_GROUPS,
  FIELD_ADD_ROOM,
  ROOM_KEYS,
};

export default PROPERTY_FORM;
